import React from 'react';
import moment from 'moment';
import { formatPhoneNumber } from '../../../utils/number-util';
import {
  formatCallOutcome,
  getResetCallState,
  getTimelineNotePreview,
  shouldShowTimelineNoteToggle,
} from '../utils/claimDrawerHelpers';

const ClaimCallLogPanel = ({
  reclamation,
  dialNumber,
  callNotes,
  setCallNotes,
  callOutcome,
  setCallOutcome,
  canLogCall,
  patchReclamation,
  refreshReclamation,
  setActiveCustomerAction,
  showCallHistory,
  setShowCallHistory,
  callHistoryItems,
  expandedTimelineNotes,
  setExpandedTimelineNotes,
  timelineNoteMax,
}) => {
  const handleCancel = () => {
    const nextState = getResetCallState();
    setActiveCustomerAction(nextState.activeCustomerAction);
    setCallNotes(nextState.callNotes);
    setCallOutcome(nextState.callOutcome);
  };

  const handleSave = () => {
    if (!callNotes.trim() || !patchReclamation || !canLogCall) return;
    patchReclamation({
      reclamation: {
        id: reclamation.id,
        activityType: 'call_logged',
        activityDetails: {
          calledAt: new Date().toISOString(),
          outcome: callOutcome,
          note: callNotes.trim(),
        },
      },
      callback: () => {
        refreshReclamation();
        const nextState = getResetCallState();
        setActiveCustomerAction(nextState.activeCustomerAction);
        setCallNotes(nextState.callNotes);
        setCallOutcome(nextState.callOutcome);
      },
    });
  };

  return (
    <>
      <div className="drawer-call-log">
        <div className="drawer-call-log-header">
          <div className="drawer-call-log-title">Log Phone Call</div>
          {dialNumber && (
            <a className="drawer-call-log-link" href={`tel:${dialNumber}`}>
              <i className="uil uil-phone" />
              Dial {formatPhoneNumber(reclamation.customerPhone)}
            </a>
          )}
        </div>
        <textarea
          className="form-control drawer-call-log-input"
          rows={4}
          placeholder="Enter call notes (e.g., discussed repair timeline, customer agreed to...)"
          value={callNotes}
          onChange={(event) => setCallNotes(event.target.value)}
        />
        <label className="drawer-follow-up-label" htmlFor="callOutcome">
          Call Outcome
        </label>
        <select
          id="callOutcome"
          className="form-control drawer-follow-up-input"
          value={callOutcome}
          onChange={(event) => setCallOutcome(event.target.value)}
        >
          <option value="connected">Connected</option>
          <option value="left_voicemail">Left voicemail</option>
          <option value="no_answer">No answer</option>
          <option value="busy">Busy</option>
        </select>
        <div className="drawer-call-log-actions">
          <button type="button" className="button inverted" onClick={handleCancel}>
            Cancel
          </button>
          <button
            type="button"
            className="button primary"
            disabled={!callNotes.trim() || !canLogCall}
            onClick={handleSave}
          >
            Save Call Log
          </button>
        </div>
      </div>
      <div className="drawer-action-history">
        <button
          type="button"
          className="button inverted drawer-action-history-toggle"
          onClick={() => setShowCallHistory((prev) => !prev)}
        >
          {showCallHistory ? 'Hide Call History' : 'Show Call History'}
        </button>
        {showCallHistory &&
          (callHistoryItems.length > 0 ? (
            <div className="drawer-action-history-list">
              {callHistoryItems.slice(0, 5).map((item, index) => {
                const timelineKey = item.id || item.createdAt || index;
                return (
                  <div key={timelineKey} className="drawer-list-item">
                    <div style={{ color: '#6b7280', fontSize: '0.85rem' }}>
                      {item.createdAt ? moment(item.createdAt).format('MMM D, YYYY h:mm A') : ''}
                    </div>
                    <div className="drawer-action-history-detail">
                      {item.details?.outcome && (
                        <div className="drawer-timeline-outcome">
                          Outcome: {formatCallOutcome(item.details.outcome)}
                        </div>
                      )}
                      {item.details?.note && (
                        <div>
                          {getTimelineNotePreview(
                            item.details.note,
                            expandedTimelineNotes[timelineKey],
                            timelineNoteMax
                          )}
                          {shouldShowTimelineNoteToggle(item.details.note, timelineNoteMax) && (
                            <button
                              type="button"
                              className="drawer-timeline-note-toggle"
                              onClick={() =>
                                setExpandedTimelineNotes((prev) => ({
                                  ...prev,
                                  [timelineKey]: !prev[timelineKey],
                                }))
                              }
                            >
                              {expandedTimelineNotes[timelineKey] ? 'Show Less' : 'Show More'}
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="drawer-action-history-empty">No call history yet.</div>
          ))}
      </div>
    </>
  );
};

export default ClaimCallLogPanel;
